import type { EditableAmountRow } from '@/core/models/notes.models';
import { DataTable, type DataTableColumn } from '@/kit/DataTable';
import { InputField } from '@/kit/FormField';

/** The fixed name column plus editable Current Year / Previous Year cells every amount note shares. */
export function AmountRowsTable({
  rows,
  onCellChange,
  onCellBlur,
  isTotal,
  nameHeaderClassName,
}: {
  rows: EditableAmountRow[];
  onCellChange: (index: number, column: 'current' | 'previous', value: string) => void;
  /** Staff costs recomputes its Total row when a cell loses focus. */
  onCellBlur?: () => void;
  /** Read-only rows (the computed Total). */
  isTotal?: (index: number) => boolean;
  nameHeaderClassName?: string;
}) {
  const cell = (column: 'current' | 'previous') => (row: EditableAmountRow, index: number) => (
    <InputField
      fieldClassName="w-200"
      autoComplete="off"
      charMode="number"
      extraChars=",.£()- "
      value={row[column]}
      readOnly={isTotal?.(index) ?? false}
      onChange={(event) => onCellChange(index, column, event.target.value)}
      onBlur={onCellBlur}
    />
  );

  const columns: DataTableColumn<EditableAmountRow>[] = [
    {
      id: 'name',
      header: '',
      headerClassName: nameHeaderClassName,
      cell: (row) => (
        <div className="d-flex">
          <div className="white-space-nowrap">{row.name}</div>
        </div>
      ),
    },
    { id: 'current', header: 'Current Year', cell: cell('current') },
    { id: 'previous', header: 'Previous Year', cell: cell('previous') },
  ];

  return (
    <div className="mat-table-wrapper">
      <DataTable columns={columns} rows={rows} rowKey={(_, index) => index} />
    </div>
  );
}
